document.addEventListener('DOMContentLoaded', () => {
	const page = document.querySelector('.page');
	const switcher = document.querySelector('.switcher');

	if (!switcher) return;

	const switcherOpen= document.querySelector('.switcher__button--open');
	const switcherClose = document.querySelector('.switcher__button--close');

	const showBanner = () => {
		if (switcher.classList.contains('switcher--hide')) {
			switcher.classList.remove('switcher--hide');
		}

		page.classList.add('page--fixed');
	};

	const closeBanner = () => {
		switcher.classList.add('switcher--hide');

		if (page.classList.contains('page--fixed')) {
			page.classList.remove('page--fixed');
		}
	};

	switcherOpen.addEventListener('click', () => {
		showBanner();
	});

	switcherClose.addEventListener('click', () => {
		closeBanner();
	});
});